import { GeofencesIndexPage, GeofencesRoute } from './-components';
import { createFileRoute, useRouter } from '@tanstack/react-router';

function GeofencesIndexRoute() {
  const router = useRouter();

  return (
    <GeofencesRoute
      requireGeoset
      permission="journeys/geofences/view"
      redirectTo={(params) =>
        router.buildLocation({
          to: '/workspaces/$workspaceId/geosets',
          params: { workspaceId: params.workspaceId },
        }).href
      }
    >
      <GeofencesIndexPage />
    </GeofencesRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/')({
  component: GeofencesIndexRoute,
});
